export default {
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        value: 0,
        min: {
            type: Number,
            default: -300000
        },
        max: {
            type: Number,
            default: 30000
        },
        disabled: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onChange(newValue) {
            this.$emit('change', newValue);
        }     
    }
};
